const PUBLIC_IMAGE_FIELDS = [
  "resolved_image_url",
  "image_url",
  "source_image_url",
  "primary_image_url",
  "prize_image_url",
  "featured_image_url",
  "botb_image_url",
  "click_image_url",
  "aspire_image_url",
  "thumbnail_url",
];

const validHttpImage = (value) => {
  if (!value) return false;
  try {
    const url = new URL(String(value));
    return url.protocol === "https:" || url.protocol === "http:";
  } catch {
    return false;
  }
};

export function publicImageResolutionForCompetition(comp = {}) {
  const safeSourceImage = comp.image_public_trusted === true || [
    "source_match", "exact_match", "close_match", "generated_render",
  ].includes(comp.asset_resolution_status);
  for (const field of PUBLIC_IMAGE_FIELDS) {
    if (!["resolved_image_url", "image_url"].includes(field) && !safeSourceImage) {
      continue;
    }
    if (validHttpImage(comp[field])) {
      return { url: comp[field], reason: `resolved_from_${field}`, field };
    }
  }
  return { url: null, reason: "competition_image_missing", field: null };
}

export function publicImageUrlForCompetition(comp = {}) {
  return publicImageResolutionForCompetition(comp).url;
}
